//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      loading: false,
      password: '',
      newPassword: '',
      newPasswordCheck: '',
      errors: [],
      success: false,
    };
  },
  computed: {
    filled() {
      return this.password && this.newPassword && this.newPasswordCheck;
    },
    hasError() {
      return this.errors.length > 0;
    },
  },
  methods: {
    save() {
      if (!this.filled) return;
      this.loading = true;
      this.errors = [];
      if (this.newPassword !== this.newPasswordCheck) {
        this.loading = false;
        this.errors.push('Nová hesla se neshodují');
        return;
      }
      const data = {
        action: 'vue_reset_password',
        password: btoa(this.password),
        newPassword: btoa(this.newPassword),
      };
      $.ajax({
        type: 'POST',
        url: wc_add_to_cart_params.ajax_url,
        data,
        success: () => {
          this.loading = false;
          this.success = true;
          this.password = '';
          this.newPassword = '';
          this.newPasswordCheck = '';
        },
        error: ({ responseJSON }) => {
          const { data } = responseJSON;
          const { error } = data;
          this.errors.push(error);
          this.loading = false;
        },
      });
    },
  },
};



// WEBPACK FOOTER //
// ./scripts/vue/auth/partials/ChangePassword.vue